import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import './admin.css';

export default function AdminProtectedRoute({ children }) {
  const { authenticated, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="adm adm-loading">
        <span className="adm-spinner" /> Checking session…
      </div>
    );
  }
  if (!authenticated) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }
  return children;
}
